import Chart from 'chart.js';

var egogramChart = <HTMLCanvasElement> document.getElementById('egogram-chart');
var score = JSON.parse(egogramChart.dataset.score);

var ctx = egogramChart.getContext('2d');
var gradientStroke = ctx.createLinearGradient(0, 0,0, 200);
gradientStroke.addColorStop(.5, 'rgba(230, 80, 45, 0.8)');
gradientStroke.addColorStop(1, 'rgba(233, 139, 57, 0.2)');

new Chart(ctx, {
    type: 'line',
    data: {
        label: 'hogehoge',
        labels: ['理念力', '支援力', '論理力', '活発力', '協同力'],
        datasets: [{
            data: score,
            backgroundColor: gradientStroke,
            borderColor: gradientStroke
        }]
    },
    options: {
        legend: {
            display: false
        },
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    min: 0,
                    max: 20
                }
            }]
        }
    }
});

const factorHeadlines = document.getElementsByClassName('factor-headline-js');
var headLineActiveClass = 'egogram-container__sub-headline-active';
var headLineInactiveClass = 'egogram-container__sub-headline-inactive';

for (let i=0, len=factorHeadlines.length|0; i<len; i=i+1|0) {
    factorHeadlines[i].addEventListener('click', () => {
        if (factorHeadlines[i].classList.contains(headLineActiveClass)) {
            // なにもしない
        } else if (factorHeadlines[i].classList.contains(headLineInactiveClass)) {
            if (factorHeadlines[i].classList.contains('factors-js')) {
                document.getElementsByClassName('egogram-container__factors')[0].classList.remove('is-hidden');
                document.getElementsByClassName('egogram-container__factors_competition')[0].classList.add('is-hidden');
            } else if (factorHeadlines[i].classList.contains('competition-js')) {
                document.getElementsByClassName('egogram-container__factors_competition')[0].classList.remove('is-hidden');
                document.getElementsByClassName('egogram-container__factors')[0].classList.add('is-hidden');
            }

            factorHeadlines[i].classList.remove(headLineInactiveClass);
            factorHeadlines[i].classList.add(headLineActiveClass);

            const toggleHeadline = <HTMLButtonElement>(factorHeadlines[i - 1] ?? factorHeadlines[i + 1]);
            toggleHeadline.classList.remove(headLineActiveClass);
            toggleHeadline.classList.add(headLineInactiveClass);
        }
    });
}

document.getElementById('js-unlimited-form').addEventListener('ajax:complete', () => {
    document.getElementById('egogram-container_sent-email').classList.remove('is-hidden');
    document.getElementById('egogram-container_email-form').classList.add('is-hidden');
});